import {
  Actions,
  NEXT_SCREEN,
  PAGES,
  PREVIOUS_SCREEN,
  SIGN_UP_ERROR,
} from "./actions";

export type RegistrationDetailsState = {
  name: string;
  email: string;
  errorMsg: string;
  currentScreen: string;
};

export const initialRegistrationDetailsState = {
  name: "",
  email: "",
  errorMsg: "",
  currentScreen: PAGES.DETAILS,
};

export function registrationDetailsReducer(
  state: RegistrationDetailsState,
  action: Actions,
) {
  switch (state.currentScreen) {
    case PAGES.DETAILS: {
      switch (action.type) {
        case NEXT_SCREEN: {
          return {
            ...state,
            ...action.payload,
          };
        }
        default: {
          return state;
        }
      }
    }

    case PAGES.PASSWORD: {
      switch (action.type) {
        case NEXT_SCREEN:
        case PREVIOUS_SCREEN:
        case SIGN_UP_ERROR: {
          return {
            ...state,
            ...action.payload,
          };
        }
        default: {
          return state;
        }
      }
    }

    default:
    case PAGES.ALREADY_REGISTERED: {
      return state;
    }
  }
}
